import React from "react";
import { Box, Container, Typography, Grid, Card, CardMedia } from "@mui/material";
import { useNavigate } from "react-router-dom";

const CitiesSection = ({ cities }) => {
  const navigate = useNavigate();

  const handleCityClick = (cityName) => {
    navigate(`/search-property?city=${cityName}`);
  };

  return (
    <Box sx={{ py: { xs: 8, md: 10 } }}>
      <Container maxWidth="lg">
        <Box sx={{ textAlign: "center", mb: 6 }}>
          <Typography variant="h3" fontWeight={700} sx={{ mb: 2, color: "#1a1a2e" }}>
            Available in Major Cities
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Find properties across Pakistan's leading urban centers
          </Typography>
        </Box>

        <Grid container spacing={3}>
          {cities.map((city, index) => (
            <Grid item xs={6} sm={4} md={2} key={index}>
              <Card
                onClick={() => handleCityClick(city.name)}
                sx={{
                  borderRadius: 3,
                  overflow: "hidden",
                  cursor: "pointer",
                  transition: "all 0.3s ease",
                  "&:hover": { transform: "translateY(-8px)", boxShadow: "0 12px 30px rgba(0,0,0,0.15)" },
                }}
              >
                <Box sx={{ position: "relative", height: 140 }}>
                  <CardMedia
                    component="img"
                    height="140"
                    image={city.image}
                    alt={city.name}
                    sx={{ filter: "brightness(0.7)" }}
                  />
                  <Box
                    sx={{
                      position: "absolute",
                      bottom: 0,
                      left: 0,
                      right: 0,
                      p: 1.5,
                      background: "linear-gradient(transparent, rgba(0,0,0,0.8))",
                    }}
                  >
                    <Typography variant="subtitle1" fontWeight={700} sx={{ color: "white" }}>
                      {city.name}
                    </Typography>
                    <Typography variant="caption" sx={{ color: "rgba(255,255,255,0.8)" }}>
                      {city.propertyCount}+ Properties
                    </Typography>
                  </Box>
                </Box>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default CitiesSection;
